import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button';
import { FieldErrorDirective, FormFieldComponent } from '@shared/components/form-field';
import { InputComponent } from '@shared/components/input';
import { ModalFooterDirective, ModalShellComponent } from '@shared/components/modal';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { suivreFormulaire } from '../../../../partage/forms/suivre-formulaire';
import { GestionManuelleDialogData, GestionManuelleResult } from '../gestion-manuelle.interface';

@Component({
  selector: 'app-dialog-gestion-manuelle',
  imports: [
    ModalShellComponent,
    ModalFooterDirective,
    ButtonComponent,
    FormFieldComponent,
    FieldErrorDirective,
    InputComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './dialog-gestion-manuelle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dialog-gestion-manuelle.component.scss',
})
export class DialogGestionManuelleComponent {
  readonly dialogRef = inject(DialogRef);
  readonly data = inject<GestionManuelleDialogData>(DIALOG_DATA);

  gestionManuelleForm = new FormGroup({
    commentaire: new FormControl<string>(
      { value: '', disabled: false },
      {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(3), Validators.maxLength(500)],
      },
    ),
  });

  // Lu par le gabarit : erreurs et validité notifiées à chaque validation
  protected readonly gestionManuelleFormSuivi = suivreFormulaire(this.gestionManuelleForm);

  submit(): void {
    const result: GestionManuelleResult = {
      commentaire: this.gestionManuelleForm.value.commentaire!,
    };
    this.dialogRef.close(result);
  }

  close(): void {
    this.dialogRef.close();
  }
}
